<template>

    <div class="mb-3" :id="id">

        <label v-if="label">
            {{ translatedLabel }}
            <span v-if="help">
                <i class="bi bi-question-circle" :title="help"></i>
            </span>
        </label>

        <div class="form-check mb-1" v-for="(text, index) in options" :key="index">
            <input type="radio" 
                   :id="id + index" 
                   :name="id" 
                   v-bind="$attrs" 
                   class="form-check-input" 
                   :value="index"
                   :checked="index == checked"
                   :class="{ 'is-invalid': error }" 
                   @change="$emit('change', index)" />
            <label class="form-check-label" :for="id + index">
                {{ text }}
            </label>
        </div>

        <div v-if="error" class="invalid-feedback">{{ error }}</div>

    </div>

</template>

<script>
    export default {
        inheritAttrs: false,
        model: {
            event: 'change'
        },
        props: {
            id: {
                type: String,
                default() {
                    return `radios-input-${this._uid}`
                },
            },
            checked: {
                type: [String, Number, Boolean, Object],
                default: null,
            },
            options: {
                type: [Object],
                required: true,
            },
            label: String,
            error: String,
            help: String,

        },
        computed: {
            translatedLabel() {
                return this.langHas('validation.attributes.' + this.label)
                        ? this.__('validation.attributes.' + this.label)
                        : this.label;
            }
        },
        methods: {
        },
    }
</script>